module.exports = __webpack_public_path__ + "static/media/013.53c949c4.jpg";